import React from 'react'
import '../../index.css'
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import jerusalem from '../../Assets/Img/jerusalem.png'

const Chap10 = () => {
  return (
    <div className="chapter-container">

      <div className="chapterFooter">
          <Link to="/Chap9">Previous</Link>
          <Link to="/">Home</Link>
          <Link to="/Chap11">Next</Link>
      </div>

      <h1 className='chapterHeading'>Chapter 10: Zion Established in Jerusalem Among the Jews</h1>

      <img src={jerusalem} className='image' alt='Wailing wall at Jerusalem' />

    <div className="wrapper">


    <div className='paragraph'>
          <p>In 1831, Joseph revealed that the events of the last days would come to pass in the generation of 
            the Jews then living. “And it shall come to pass, that this generation of Jews shall not pass away until every desolation 
            which I have told you concerning them shall come to pass.”  
            <btn id="clickable1" className="footnote">1 </btn>
            <Tooltip anchorSelect="#clickable1" className="footnote-size" clickable>D&C 45:21.</Tooltip>
            
            Again, if a generation is 20-30  years, 
            <btn id="clickable2" className="footnote">2 </btn>
            <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>Jack Fenner, 28 March 2005, Cross-Cultural Estimation of the Human Generation Interval for Use in Genetics-Based Population Divergence Studies, American Journal of Physical Anthropology. 128: 415–423.</Tooltip>
            
            according to Joseph in 1831, “every desolation … shall come to pass” to the 
            Jews by the 1860s. Then Christ would appear shortly thereafter.
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph revealed, “Judah must return, Jerusalem must be rebuilt, and the temple, and water come out from under the temple, 
            and the waters of the Dead Sea be healed … It will take some time to rebuild the walls of the city and the temple … 
            and all this must be done before the Son of Man will make his appearance”  
            <btn id="clickable3" className="footnote">3 </btn>
            <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>History of the Church, vol. 5, p. 337.</Tooltip>
            
            Joseph prophesied to the early Mormons that Christ would not only assist the Jews in returning to Jerusalem but also establish a second Zion there through the priesthood – just like Zion in Jackson County. In this second Zion, Christ will establish his throne and rule from this power center during the Millennium. From this throne in the second Zion, Christ will rightfully be King of Kings and Lord of Lords, and rule over all the kingdoms of the world.
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph also told early Mormons that they would assist the Jews in their prophesied return to Palestine and establishing a 
            second Zion in Jerusalem. First Presidency Counselor Heber Kimball stated that Joseph said, “The day will be when I will 
            see those men in the general assembly of the Church of the First-Born, in the great council of God in Jerusalem.” 
            Heber added, referring to Zion in Jackson County and Zion in Jerusalem, “I heard Joseph say twice that brother Brigham 
            and I should be in that council in Jerusalem, when there should be a uniting of the two divisions of God’s government.” 
            <btn id="clickable4" className="footnote">4 </btn>
            <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>Heber Kimball, Journal of Discourses, April 7, 1861, vol. 9, p. 27.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>First Presidency Counselor Charles Penrose explained that Christ would establish Zion in Jerusalem, the Kingdom of God 
            among the Jews, “The government of God as established in Zion will be set up among them (the Jews) no more to be 
            thrown down forever.”  
            <btn id="clickable5" className="footnote">5 </btn>
            <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>Charles Penrose, “The Second Advent,” Millennial Star, 10 Sept. 1859, pp. 582–83.</Tooltip>
            
            Mormon Apostle Parley Pratt stated, “There [Jerusalem] also the Messiah establishes his throne, and seat of government. 
            Jerusalem then becomes the seat of empire, and the great centre and capital of the old world.” Parley continued, 
            “... In short, the kings, rulers, priests and people … shall know this once that there is a God in Israel, who, 
            as in days of old, can utter his voice, and it shall be obeyed. The courts of Rome, London, Paris, Constantinople, 
            Petersburg, and all others, will then have to yield the point, and do homage, and all pay tribute to one Great Centre, 
            and to one mighty Sovereign, or Thrones will be cast down, and kingdoms will cease to be.”
            <btn id="clickable6" className="footnote">6 </btn>
            <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>Proclamation Of The Twelve Apostles Of The Church Of Jesus Christ, Of Latter-Day Saints, (New York, 1845), p. 7-8.</Tooltip>
          </p>
        </div>

        <h2 className="headlinePadding">Dedicating the Holy Land </h2>

        <div className='paragraph'>
          <p>In 1831, Joseph revealed that the appointed time had arrived to begin preparing for the Jews to return to their homeland. 
            Joseph revealed, “Let them who be of Judah flee unto Jerusalem, unto the mountains of the Lord’s house.”  
            <btn id="clickable7" className="footnote">7 </btn>
            <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>D&C 133:13.</Tooltip>
            
            The next year in 1832, Joseph blessed Orson Hyde and pronounced, “In due time thou shalt go to Jerusalem, the land of thy 
            fathers, and be a watchman unto the house of Israel; and by thy hands shall the Most High do a great work, which shall 
            prepare the way and greatly facilitate the gathering together of that people.”
            <btn id="clickable8" className="footnote">8 </btn>
            <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>History of the Church, vol. 4, p. 375.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>In April 1840, Joseph sent Orson Hyde to dedicate Jerusalem for the return of the Jews, and to encourage the leaders 
            of the Jews to begin the work of gathering. Joseph wrote to Orson and his companion, “Brethren, you are in the pathway 
            to eternal fame, and immortal glory, and inasmuch as you feel interested for the covenant people of the Lord, 
            the God of their fathers shall bless you.”  
            <btn id="clickable9" className="footnote">9 </btn>
            <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>History of the Church, vol., 4, p. 128.</Tooltip>
            
            On October 24, 1841, Orson ascended the Mount of Olives and dedicated Jerusalem “for the gathering together of Judah’s 
            scattered remnants, according to the predictions of the holy Prophets.”  
            <btn id="clickable10" className="footnote">10 </btn>
            <Tooltip anchorSelect="#clickable10" className="footnote-size"  clickable>History of the Church, vol., 4, p. 456-457.</Tooltip>
            
            But needless to say, the Jews did not return 
            by the 1860s, and no second Zion was ever established in Jerusalem.
          </p>
        </div>

        <h2 className="headlinePadding">Three Visits of Christ</h2>

        <div className='paragraph'>
          <p>First Presidency Counselor Charles Penrose explained that Christ will appear (before his Second Coming) to the Jews at Jerusalem to set up his kingdom – the second Zion. Charles describes three visits that Christ would make to the earth. The first is to Zion in Jackson County. The second is to the Jews in Jerusalem. The third is Christ’s Second Coming in glory.
          </p>
        </div>

        <div className='paragraph'>
          <p>Discussing his first appearance to Zion in Jackson County, Charles states, “Among the first-mentioned of these three classes of men the Lord will make his appearance first; and that appearance will be unknown to the rest of mankind. He will come to the Temple prepared for him, and his faithful people will behold his face, hear his voice, and gaze upon his glory. From his own lips they will receive further instructions for the development and beautifying of Zion and for the extension and sure stability of his kingdom.”
          </p>
        </div>

        <div className='paragraph'>
          <p>Then Christ will appear to the Jews at Jerusalem. “His next appearance will be among the distressed and nearly vanquished sons of Judah. At the crisis of their fate, when the hostile troops of several nations are ravaging the city and all the horrors of war are overwhelming the people of Jerusalem, he will set his feet upon the Mount of Olives, which will cleave and part asunder at his touch.” 
          </p>
        </div>

        <div className='paragraph'>
          <p>Charles continued, “Attended by a host from heaven, he will overthrow and destroy the combined armies of the Gentiles and appear to the worshipping Jews as the mighty Deliverer and Conqueror so long expected by their race; and while love, gratitude, awe, and admiration swell their bosoms, the Deliverer will show them the tokens of his crucifixion and disclose himself as Jesus of Nazareth, whom they had reviled and whom their fathers put to death. Then will unbelief part from their souls, and ‘the blindness in part which has happened unto Israel’ be removed. ‘A fountain for sin and uncleanness shall be opened to the house of David and the inhabitants of Jerusalem,’ and ‘a nation will be born’ unto God ‘in a day.’ They will be baptized for the remission of their sins, and will receive the gift of the Holy Ghost, and the government of God as established in Zion will be set up among them, no more to be thrown down forever.”
          </p>
        </div>

        <div className='paragraph'>
          <p>Then, Charles provides a brief glimpse of the Second Coming. “The great and crowning advent of the Lord will be subsequent 
            to these two appearances; but who can describe it in the language of mortals? The tongue of man falters, and the pen drops 
            from the hand of the writer, as the mind is rapt in contemplation of the sublime and awful majesty of his coming to take 
            vengeance on the ungodly and to reign as King of the whole earth.” 
            <btn id="clickable11" className="footnote">11 </btn>
            <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>Charles Penrose, “The Second Advent,” Millennial Star, 10 Sept. 1859, pp. 582–83.</Tooltip>
          </p>
        </div>

        <h2 className="headlinePadding">The Jews to Receive the Restored Gospel at Jerusalem</h2>

        <div className='paragraph'>
          <p>At Christ’s appearance in Jerusalem (before the Second Coming), there will be a group of Jewish people who convert to 
            Mormonism. Charles explained, “Then will disbelief depart from their souls and the blindness in part which has happened 
            unto Israel be removed.”  
            <btn id="clickable12" className="footnote">12 </btn>
            <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>Charles Penrose, “The Second Advent,” Millennial Star, 10 Sept. 1859, pp. 582–83.</Tooltip>
            
            According to Mormon prophets, this refers to Isaiah’s prophecy that a “A nation will be born unto God in a day.” 
            <btn id="clickable13" className="footnote">13 </btn>
            <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>Isaiah 66:8-9.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>But not all Jews will accept the restored gospel. We know this because the Bible explains that there will be unbelieving 
            Jews at Christ’s Second Coming. At this appearance to establish Zion, Christ will cleanse the temple at Jerusalem. 
            Mormon prophets testified that the Old Testament Prophet Zechariah referred to this when he wrote, “In that day there 
            shall be a fountain opened to the house of David and to the inhabitants of Jerusalem for sin and for uncleanness.”
            <btn id="clickable14" className="footnote">14 </btn>
            <Tooltip anchorSelect="#clickable14" className="footnote-size" clickable>Zechariah 13:1.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>While in Jerusalem, Christ would preach the restored gospel to the Jews. He would baptize them, confer the priesthood, 
            and administer temple ordinances. Mormon prophets have taught that this is what Isaiah referred to when he counseled the 
            Jews “… put on thy strength, O Zion, put on thy beautiful garments.”  
            <btn id="clickable15" className="footnote">15 </btn>
            <Tooltip anchorSelect="#clickable15" className="footnote-size" clickable>Isaiah 52:1.</Tooltip>
            
            The Jews will be clothed with the robes of righteousness, with the endowment of glory; and they will be prepared in every 
            way for the revelation of Christ in glory and the great marriage feast of the Lamb of God. 
            <btn id="clickable16" className="footnote">16 </btn>
            <Tooltip anchorSelect="#clickable16" className="footnote-size" clickable>Revelation 19:4-9.</Tooltip>
          </p>
        </div>

        <h2 className="headlinePadding">King David’s Ancient Throne</h2>

        <div className='paragraph'>
          <p>To fulfil biblical prophecy, a government must be established at Jerusalem. According to Joseph Smith, the political system to be established in the second Zion at Jerusalem will be a restoration of King David’s ancient throne and kingdom. Joseph taught that a descendant of King David, whose name will also be David, will direct the operations of the government of God on earth, under Christ. 
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph explained, “Although David was a king he never did obtain the spirit and power of Elijah and the fulness of the 
            Priesthood; and the Priesthood that he received, and the throne and kingdom of David is to be taken from him and given 
            to another by the name of David in the last days, raised up out of his lineage.”  
            <btn id="clickable17" className="footnote">17 </btn>
            <Tooltip anchorSelect="#clickable17" className="footnote-size" clickable>History of the Church, vol. 4, p. 253.</Tooltip>
            
            Joseph revealed, “Through this order, he (Christ) may be glorified, and ... through the power of anointing, David may 
            reign king over Israel.”  
            <btn id="clickable18" className="footnote">18 </btn>
            <Tooltip anchorSelect="#clickable18" className="footnote-size" clickable>Revelation given through Joseph Smith to Newel K. Whitney, Nauvoo, Illinois, July 27, 1842.</Tooltip>
            
            Joseph most likely derived this idea from Ezekiel, who had much to say about the future David.  Ezekiel prophesied, “I will set up one shepherd over them, and he shall feed them, even my servant David; ... and I the Lord will be their God, and my servant David a prince among them.”
          </p>
        </div>

        <div className='paragraph'>
          <p>Speaking of the future uniting of the 12 Tribes of Israel, Ezekiel prophesied, “One king shall be king to them all: and 
            they shall be no more ... divided into two kingdoms... And David my servant shall be king over them; and they all shall 
            have one shepherd, ... and my servant David shall be their prince forever.”
            <btn id="clickable19" className="footnote">19 </btn>
            <Tooltip anchorSelect="#clickable19" className="footnote-size" clickable>Ezekiel 37:25.</Tooltip>
          </p>
        </div>
    
        </div>

        <div className="chapterFooter">
          <Link to="/Chap9">Previous</Link>
          <Link to="/">Home</Link>
          <Link to="/Chap11">Next</Link>
      </div>
      
    </div>
  )
}

export default Chap10